var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('eventi-list-component',{key:_vm.keyListaEventi,attrs:{"utente":_vm.utente,"titoloEvento":_vm.titoloEvento,"pathEventResource":_vm.pathEventResource,"linkEvent":_vm.linkEvent,"tipoEvento":"ECOCARDIO DATI"}})}
var staticRenderFns = []

export { render, staticRenderFns }